import React, { useEffect, useState } from "react";
import { Box, Button, ButtonGroup, Paper } from "@mui/material";
import {
  userInfoResponse,
  userRoleResponse,
} from "@/models/equip-api-response-objects/userInfoResponse";
import CustomDatasets from "./customDatasets/customDatasets";
import Coverage from "./coverage/coverage";
import Dashboard from "./dashboard/dashboard";
import BatchCache from "./batchCache/batchCache";
import { equipOptionsInstance } from "@/models/EquipOptions";
import { GetUserInfo, GetUserRoles } from "@/services/api/user-endpoints";

enum ViewMode {
  Dashboard = "dashboard",
  Coverage = "coverage",
  CachedData = "cached_data",
  CustomDatasets = "custom_data",
}

export default function EquipHome() {
  const [currentView, setCurrentView] = useState<ViewMode>(ViewMode.Dashboard);

  useEffect(() => {
    const initUsers = async () => {
      try {
        equipOptionsInstance.UserDetails = await GetUserInfo();
        equipOptionsInstance.UserRoles = await GetUserRoles();
      } catch (err) {
        console.error("error getting user details", err);
      }
    };
    initUsers();
  }, []);

  const renderView = () => {
    switch (currentView) {
      case ViewMode.Dashboard:
        return <Dashboard user={equipOptionsInstance.UserDetails} />;
      case ViewMode.Coverage:
        return <Coverage currentUser={equipOptionsInstance.UserDetails} />;
      case ViewMode.CustomDatasets:
        return <CustomDatasets />;
      case ViewMode.CachedData:
        return <BatchCache />;
    }
  };

  return (
    <Box>
      <Paper sx={{ minHeight: 400, mb: 2 }}>{renderView()}</Paper>

      <Box
        sx={{
          position: "fixed",
          bottom: 0,
          left: 0,
          right: 0,
          display: "flex",
          justifyContent: "center",
          py: 2,
          bgcolor: "background.paper",
          borderTop: 1,
          borderColor: "divider",
          boxShadow: 2,
        }}
      >
        <ButtonGroup variant="outlined">
          <Button
            variant={currentView === ViewMode.Dashboard ? "contained" : "outlined"}
            onClick={() => setCurrentView(ViewMode.Dashboard)}
          >
            Dashboard
          </Button>
          <Button
            variant={currentView === ViewMode.Coverage ? "contained" : "outlined"}
            onClick={() => setCurrentView(ViewMode.Coverage)}
          >
            Coverage
          </Button>
          <Button
            variant={currentView === ViewMode.CustomDatasets ? "contained" : "outlined"}
            onClick={() => setCurrentView(ViewMode.CustomDatasets)}
          >
            Custom Datasets
          </Button>
          <Button
            variant={currentView === ViewMode.CachedData ? "contained" : "outlined"}
            onClick={() => setCurrentView(ViewMode.CachedData)}
          >
            Cached Data
          </Button>
        </ButtonGroup>
      </Box>
    </Box>
  );
}
